import React, { useCallback, useEffect, useState, useRef } from 'react';
const BEFORE_IMAGE = 'https://cdn.magicpatterns.com/uploads/eovhFYZhVLDoVYvrkpBrdt/despues.jpg';
const AFTER_IMAGE = 'https://cdn.magicpatterns.com/uploads/bJCnfrpvcbcU86EFP6ZnmX/antes.png';
export function BeforeAfterSlider() {
  const [position, setPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerSize, setContainerSize] = useState({
    w: 0,
    h: 0
  });
  useEffect(() => {
    const update = () => {
      if (containerRef.current) {
        setContainerSize({
          w: containerRef.current.offsetWidth,
          h: containerRef.current.offsetHeight
        });
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  const updatePosition = useCallback((clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percent = Math.max(0, Math.min(100, x / rect.width * 100));
    setPosition(percent);
  }, []);
  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
    updatePosition(e.clientX);
  }, [updatePosition]);
  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    if (!isDragging) return;
    updatePosition(e.clientX);
  }, [isDragging, updatePosition]);
  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    setIsDragging(true);
    updatePosition(e.touches[0].clientX);
  }, [updatePosition]);
  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (!isDragging) return;
    updatePosition(e.touches[0].clientX);
  }, [isDragging, updatePosition]);
  const handleTouchEnd = useCallback(() => {
    setIsDragging(false);
  }, []);
  return <div ref={containerRef} className="relative w-full rounded-2xl overflow-hidden glow-border cursor-col-resize select-none" style={{
    aspectRatio: '16/9'
  }} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-10">
      {/* After Image (full background - portrait image rotated to landscape) */}
      <div className="absolute inset-0" data-id="element-11">
        <div className="absolute" style={{
        width: containerSize.h || '56.25vw',
        height: containerSize.w || '100vw',
        transformOrigin: 'top left',
        transform: 'rotate(-90deg) translateX(-100%)',
        top: 0,
        left: 0
      }} data-id="element-12">
          <img src={AFTER_IMAGE} alt="Con LUT" className="w-full h-full object-cover" draggable={false} data-id="element-13" />
        </div>
      </div>

      {/* Before Image (landscape, clipped by slider position) */}
      <div className="absolute inset-0" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} data-id="element-14">
        <img src={BEFORE_IMAGE} alt="Sin LUT" className="absolute inset-0 w-full h-full object-cover" draggable={false} data-id="element-15" />
      </div>

      {/* Divider Line */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_8px_rgba(255,255,255,0.5)]" style={{
      left: `${position}%`,
      transform: 'translateX(-50%)'
    }} data-id="element-16" />

      {/* Handle */}
      <div className="absolute top-1/2 -translate-y-1/2 z-10" style={{
      left: `${position}%`,
      transform: 'translate(-50%, -50%)'
    }} data-id="element-17">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/90 backdrop-blur-sm border-2 border-white shadow-[0_0_20px_rgba(59,130,246,0.4)] flex items-center justify-center transition-transform duration-150 ${isDragging ? 'scale-110' : 'hover:scale-110'}`} data-id="element-18">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="text-gray-800" data-id="element-19">
            <path d="M6 10L2 10M2 10L4.5 7.5M2 10L4.5 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-20" />
            <path d="M14 10L18 10M18 10L15.5 7.5M18 10L15.5 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-21" />
          </svg>
        </div>
      </div>

      {/* Labels */}
      <div className="absolute top-3 left-3 md:top-4 md:left-4 bg-black/70 backdrop-blur-sm px-3 py-1.5 rounded-lg border border-white/10" data-id="element-22">
        <span className="text-[10px] md:text-xs font-black tracking-widest text-white/80" data-id="element-23">
          SIN LUT
        </span>
      </div>
      <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-black/70 backdrop-blur-sm px-3 py-1.5 rounded-lg border border-primary/30" data-id="element-24">
        <span className="text-[10px] md:text-xs font-black tracking-widest text-primary" data-id="element-25">
          CON LUT
        </span>
      </div>
    </div>;
}